import { TAutoReplyBusinessHour, TAutoReplyWeekday } from 'api';

export const AUTO_REPLY_TABS = ['uniform', 'keyword', 'time'] as const;

// backend の AUTO_REPLY_CHAT_LINK_*_MAX_LENGTH（LINE buttons templateの上限）と揃える
export const AUTO_REPLY_CHAT_LINK_TEXT_MAX_LENGTH = 160;
export const AUTO_REPLY_CHAT_LINK_BUTTON_MAX_LENGTH = 20;
export type AutoReplyTabKey = (typeof AUTO_REPLY_TABS)[number];

export const AUTO_REPLY_WEEKDAYS: TAutoReplyWeekday[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const DEFAULT_BUSINESS_HOURS: TAutoReplyBusinessHour[] =
  AUTO_REPLY_WEEKDAYS.map((weekday) => ({
    weekday,
    closed: false,
    startTime: '09:00',
    endTime: '18:00',
  }));
